import { render, staticRenderFns } from "./PaginationV2.vue?vue&type=template&id=78c7de5a&scoped=true&"
import script from "./PaginationV2.vue?vue&type=script&lang=js&"
export * from "./PaginationV2.vue?vue&type=script&lang=js&"
import style0 from "./PaginationV2.vue?vue&type=style&index=0&id=78c7de5a&scoped=true&lang=css&"
import style1 from "./PaginationV2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c7de5a",
  null
  
)

export default component.exports